export default "__VITE_ASSET__BfbNCjo0__ 1200w";